import { action, Action, thunk, Thunk, computed, Computed } from 'easy-peasy';
import {
  SubscribeToExternalHedgesParams,
  subscribeToExternalHedges,
} from 'services/firebase/externalHedges';
import { ICurrency, Nullable } from 'types';
import { IExternalHedge } from 'types/externalHedges';

export interface ExternalHedgesStateModel {
  externalHedges: IExternalHedge[];
  isLoadingExternalHedges: boolean;
  setState: Action<ExternalHedgesStateModel, [string, any]>;
  subscribeToExternalHedges: Thunk<
    ExternalHedgesStateModel,
    Omit<SubscribeToExternalHedgesParams, 'callback'>,
    null,
    object
  >;
  externalHedgesByCurrency: Computed<
    ExternalHedgesStateModel,
    (buyCurrencyCode: ICurrency['code']) => IExternalHedge[]
  >;
  externalHedgeById: Computed<
    ExternalHedgesStateModel,
    (id: Nullable<IExternalHedge['id']>) => IExternalHedge | null
  >;
}

export const ExternalHedgesState: ExternalHedgesStateModel = {
  externalHedges: [],
  isLoadingExternalHedges: true,
  setState: action((state, payload) => {
    const [prop, to] = payload;
    state[prop] = to;
  }),
  subscribeToExternalHedges: thunk(({ setState }, payload) => {
    return subscribeToExternalHedges({
      ...payload,
      callback: (externalHedges) => {
        setState(['externalHedges', externalHedges]);
        setState(['isLoadingExternalHedges', false]);
      },
    });
  }),
  externalHedgesByCurrency: computed(
    [(state) => state.externalHedges],
    (externalHedges) => (buyCurrencyCode) =>
      externalHedges.filter((hedge) => hedge.buyCurrency === buyCurrencyCode) ||
      []
  ),
  externalHedgeById: computed(
    [(state) => state.externalHedges],
    (externalHedges) => (id) =>
      externalHedges.find((hedge) => hedge.id === id) || null
  ),
};
